import { Pipe, PipeTransform } from '@angular/core';
import { translateAppInvitationStatus } from '../mappers/enum-translation-mapper';
import { AppInvitationStatus } from '../enums/app-invitation-status.enum';

@Pipe({
  name: 'translateAppInvitationStatusEnum',
})
export class TranslateAppInvitationStatusEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const problemTypeEnum = element as { name: any; index: any };
        problemTypeEnum.name = translateAppInvitationStatus(problemTypeEnum.index);
      });
      return value;
    } else {
      const enumValue: AppInvitationStatus = AppInvitationStatus[value as keyof typeof AppInvitationStatus];
      return translateAppInvitationStatus(enumValue);
    }
  }
}
